import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { HomeIcon } from '@ui/icons';
import { makeStyles } from '@ui/styles';
import { Skeletonize } from '@ui/components';
import { IconButton } from '../common/IconButton';
import { Typography } from '../common/Typography';
import { CopyKeyButton } from './CopyKeyButton';
import { UsageReportButton } from './usageReport';

type LicenseHeaderProps = { id: string; licenseKey: string };

const WhiteText = withStyles((theme) => ({
  root: { color: theme.palette.secondary.contrastText },
}))(Typography);
const LicenseKey = withStyles(() => ({
  root: {
    textOverflow: 'ellipsis',
    width: 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
}))(Typography);

export const Header = withStyles((theme) => ({
  root: {
    minHeight: '88px',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    '& button': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      borderColor: theme.palette.common.white,
    },
    '& button:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.common.white,
    },
  },
}))(Grid);

const useSkeletonStyles = makeStyles((theme) => ({
  root: { backgroundColor: theme.palette.grey[300] },
}));

const useButtonGroupStyles = makeStyles((theme) => ({
  root: { '& > *': { margin: theme.spacing(0, 0.5) } },
}));

export const LicenseHeader: React.FC<LicenseHeaderProps> = ({ id, licenseKey }) => {
  const skeletonClasses = useSkeletonStyles();
  const buttonGroupClasses = useButtonGroupStyles();

  return (
    <Header container alignItems='center' direction='row' justify='space-between'>
      <Grid item>
        <Skeletonize
          as={WhiteText}
          variant='h4'
          SkeletonProps={{ width: 275, height: 20, classes: skeletonClasses }}
        >
          License ID {id}
        </Skeletonize>

        <Skeletonize
          as={WhiteText}
          variant='subtitle2'
          variantMapping={{ subtitle2: 'div' }}
          SkeletonProps={{ width: 142, height: 19, classes: skeletonClasses }}
        >
          Key <LicenseKey variant='subtitle2'>{licenseKey}</LicenseKey>{' '}
          <CopyKeyButton licenseKey={licenseKey} />
        </Skeletonize>
      </Grid>

      <Grid item classes={buttonGroupClasses}>
        <UsageReportButton variant='outlined' licenseId={id} />
        <IconButton color='secondary' icon={<HomeIcon />} variant='outlined' />
      </Grid>
    </Header>
  );
};
